import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Helper from '../Helper';
import Navbar from './sub/navbar';
import JobDetail from './sub/JobDetail';
import moment from 'moment';
import Alert from './sub/dialog'
import { MDBContainer,MDBSelect, MDBCard, MDBCardBody, MDBInput, MDBBtn, MDBTypography, MDBSpinner, MDBTextArea } from 'mdb-react-ui-kit';

const CompanyProfile = () => {
  const navigate = useNavigate();
  const [company, setCompany] = useState({
    name: '',
    name_en: '',
    address: '',
    phone: '',
    email: '',
    website: '',
    taxid: '', bankaccount: '', bankaccountname: '', bankname: '', bankaccounttype: ''

  });

  const banks =Helper.bank;

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const alert = useRef();
  const setError = (message, ismessage) => (ismessage ? alert.current.showmessage(message) : alert.current.showerror(message));


  // Fetch company profile
  useEffect(() => {
 

    if (!Helper.gettoken()) {
      navigate('/login');
      return;
    }

    if (!["admin"].includes(Helper.getuserrole())) {
      navigate('/main');
      return;
    }

    fetchCompany();
  }, []);

  const fetchCompany = async () => {
    try {

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/GetcompanyProfile`, {
        headers: { 'Authorization': `Bearer ${Helper.gettoken()}`, }
      });
      const data = await response.json();
      if (data) setCompany(data);
    } catch (error) {
      setError('Error fetching company profile');
    }
  };

  // Handle input changes
  const handleChange = (e) => {
    setCompany({ ...company, [e.target.name]: e.target.value });
  };

  const handleBankChange = (selectedBank) => {
    setCompany({ ...company, bankname: selectedBank.value });
  };

  // Save company profile
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const token = sessionStorage.getItem('authToken');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/SavecompanyProfile`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Helper.gettoken()}`
        },
        body: JSON.stringify(company)
      });

      const result = await response.json();
      setError("บันทึกข้อมูลเรียบร้อยแล้ว", true);
    } catch (error) {
      console.error('Error updating company profile:', error);
      setError('Failed to update profile');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <MDBContainer fluid className="my-3">
        <Alert ref={alert} />
        <MDBCard >
          <MDBCardBody>
            <MDBTypography tag="h4" className=" mb-4">
              ข้อมูลบริษัท
            </MDBTypography>
            {message && <p className="text-center text-success">{message}</p>}
            <form onSubmit={handleSubmit}>
              <MDBInput
                label="ชื่อบริษัท"
                name="name"
                value={company.name}
                onChange={handleChange}
                required
                className="mb-3"
              />
              <MDBInput
                label="ชื่อบริษัท (ภาษาอังกฤษ)"
                name="name_en"
                value={company.name_en}
                onChange={handleChange}
                required
                className="mb-3"
              />
              <MDBTextArea
                label="ที่อยู่"
                name="address"
                value={company.address}
                onChange={handleChange}
                className="mb-3"
                rows={4}
              />
              <MDBInput
                label="เบอร์โทร"
                name="phone"
                value={company.phone}
                onChange={handleChange}
                className="mb-3"
              />
              <MDBInput
                label="Email"
                type="email"
                name="email"
                value={company.email}
                onChange={handleChange}
                className="mb-3"
              />
              <MDBInput
                label="เลขที่ภาษี"
                type="text"
                name="taxid"
                value={company.taxid}
                onChange={handleChange}
                className="mb-3"
              />
              <MDBTypography tag="h4" className=" mb-4">
                ข้อมูลบัญชี
              </MDBTypography>
              <MDBSelect
                data={banks}
              className="mb-3"
                label="ธนาคาร"
                value={company.bankname}
                onChange={handleBankChange}
              />
              <MDBInput
                label="เลขบัญชี"
                type="text"
                name="bankaccount"
                value={company.bankaccount}
                onChange={handleChange}
                className="mb-3"
              />
              <MDBInput
                label="ชื่อบัญชี"
                type="text"
                name="bankaccountname"
                value={company.bankaccountname}
                onChange={handleChange}
                className="mb-3"
              />

              <MDBInput
                label="ชนิดบัญชี"
                type="text"
                name="bankaccounttype"
                value={company.bankaccounttype}
                onChange={handleChange}
                className="mb-3"
              />
              <div className="text-center">
                <MDBBtn type="submit" disabled={loading}>
                  {loading ? <MDBSpinner size="sm" role="status" tag="span" /> : 'บันทึก'}
                </MDBBtn>
              </div>
            </form>
          </MDBCardBody>
        </MDBCard>
      </MDBContainer>
    </>
  );
};

export default CompanyProfile;
